const $video  = $('.home-video video'), $window = $(window);

$(window).resize(function(){
  let height = $window.height();
  $video.css('height', height);

  let videoWidth = $video.width(),
    windowWidth = $window.width(),
    marginLeftAdjust =   (windowWidth - videoWidth) / 2;

  $video.css({
    'height': height,
    'marginLeft' : marginLeftAdjust,
  });
}).resize();



// WEBPACK FOOTER //
// ./scripts/pages/video-player.js